import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-advertisement-added',
  templateUrl: './advertisement-added.component.html',
  styleUrls: ['./advertisement-added.component.scss']
})
export class AdvertisementAddedComponent implements OnInit {

 constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

}
